/* eslint-disable max-len */
import { faShapes, faSliders } from '@fortawesome/free-solid-svg-icons';

export const CREATE_PRO_FORMA_STEPS = {
    STEP_1: 1,
    STEP_2: 2,
};

export const CREATE_PRO_FORMA_STEP2_CARDS = [
    {
        name: 'Quick start',
        time: '3-5 MINUTES',
        description: 'Take a guided approach to enter key project details in three quick steps. This helps structure your pro forma before moving into the full setup—where you’ll have access to the same level of detail as the option below.',
        image: 'pro_forma_quick_start_frame.png',
        icon: faShapes,
    },
    {
        name: 'Start with detail',
        time: '10-15 MINUTES',
        description: 'Skip the guided steps and go straight into the full setup. A greater level of detail and visualization of cash flows will be available right away.',
        image: 'pro_forma_start_with_detail_frame.png',
        icon: faSliders,
    },
];

export const MOCK_SCENARIO_OPTIONS = [
    {
        value: 1,
        label: 'Scenario 1',
    },
    {
        value: 2,
        label: 'Scenario 2',
    },
];
